// extracted by mini-css-extract-plugin
module.exports = {"sortingWrapper":"styles_sortingWrapper__3ecn6","name":"styles_name__2olQW","infoIcon":"styles_infoIcon__IP2zi"};